import {
  APPLICATION_MANIFESTS,
  SHARED_BOTTOM_NAV,
  type WorkspaceClientId,
  type WorkspaceNavGroup,
  type WorkspaceNavItem,
} from '@/lib/applications/application-manifest';

export type { WorkspaceClientId } from '@/lib/applications/application-manifest';

export interface NavItem extends WorkspaceNavItem {}
export interface NavGroup extends WorkspaceNavGroup {}

export interface WorkspaceNavigation {
  readonly label: string;
  readonly badgeLabel: string;
  readonly homePath: string;
  readonly groups: readonly NavGroup[];
  readonly bottomNav: readonly NavItem[];
}

export const WORKSPACE_NAVIGATION: Record<WorkspaceClientId, WorkspaceNavigation> = {
  'admin-bff': {
    label: APPLICATION_MANIFESTS['admin-bff'].label,
    badgeLabel: APPLICATION_MANIFESTS['admin-bff'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['admin-bff'].homePath,
    groups: APPLICATION_MANIFESTS['admin-bff'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
  'oss-integration': {
    label: APPLICATION_MANIFESTS['oss-integration'].label,
    badgeLabel: APPLICATION_MANIFESTS['oss-integration'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['oss-integration'].homePath,
    groups: APPLICATION_MANIFESTS['oss-integration'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
  'gestion-access': {
    label: APPLICATION_MANIFESTS['gestion-access'].label,
    badgeLabel: APPLICATION_MANIFESTS['gestion-access'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['gestion-access'].homePath,
    groups: APPLICATION_MANIFESTS['gestion-access'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
  'declaration-sommaire': {
    label: APPLICATION_MANIFESTS['declaration-sommaire'].label,
    badgeLabel: APPLICATION_MANIFESTS['declaration-sommaire'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['declaration-sommaire'].homePath,
    groups: APPLICATION_MANIFESTS['declaration-sommaire'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
  'oss-referential-service': {
    label: APPLICATION_MANIFESTS['oss-referential-service'].label,
    badgeLabel: APPLICATION_MANIFESTS['oss-referential-service'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['oss-referential-service'].homePath,
    groups: APPLICATION_MANIFESTS['oss-referential-service'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
  'oss-maritime-operations': {
    label: APPLICATION_MANIFESTS['oss-maritime-operations'].label,
    badgeLabel: APPLICATION_MANIFESTS['oss-maritime-operations'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['oss-maritime-operations'].homePath,
    groups: APPLICATION_MANIFESTS['oss-maritime-operations'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
  'oss-ens': {
    label: APPLICATION_MANIFESTS['oss-ens'].label,
    badgeLabel: APPLICATION_MANIFESTS['oss-ens'].badgeLabel,
    homePath: APPLICATION_MANIFESTS['oss-ens'].homePath,
    groups: APPLICATION_MANIFESTS['oss-ens'].navGroups,
    bottomNav: SHARED_BOTTOM_NAV,
  },
};
